import algoliasearch from "algoliasearch";
import { AlgoliaFinishHit } from "../types/AlgoliaTypes";
import { algoliaConfig } from "../data/config";

const searchClient = algoliasearch("BCXURW325T", "f9ee2c1748b8d3914488faf0da618532");
const index = searchClient.initIndex(algoliaConfig.PRODUCT_INDEX)

export async function getProducts(searchQuery: string): Promise<AlgoliaFinishHit[]> {
    try { 
        const obj = await index.search(searchQuery)
        
        return obj.hits as AlgoliaFinishHit[];
    } catch (err) { 
        throw new Error(); 
    } 
}